module.exports = __webpack_public_path__ + "img/img-712d3c.jpg";